import { useEffect, useState } from 'react';
import { Carousel } from '@ss/mtd-react3';
import { getBannerList } from '@cap/share/src/apis/home';
import { Image } from '@cap/share/src/components/LazyLoadImage';
import { useRequest } from 'ahooks';
import { lx } from '@cap/rzmt-core';
import { IBanner } from '../../utils/type';
import { useAppSelector } from '@/store/hooks';
import { selectBannerId } from '@/pages/home/homeCourseData';
import './index.less';

const enum BannerStatus {
  Init,
  None,
  Succ,
}

export default () => {
  const bannerModuleId = useAppSelector(selectBannerId) as number;
  const [bannerStatus, setBannerStatus] = useState(BannerStatus.Init);
  const [bannerList, setBannerList] = useState<IBanner[]>([]);

  const handleClickBanner = (data: IBanner) => {
    lx.moduleClick({
      bid: 'b_donation_vv9hnj1u_mc',
    });
    const { url } = data;
    if (!url) return;
    window.open(url);
  };

  const renderBanner = () => {
    switch (bannerStatus) {
      case BannerStatus.Succ:
        // 判断 bannerList 的长度
        if (bannerList.length === 1) {
          // 如果只有一张图片，不使用 Carousel
          return (
            <div className="banner-item" onClick={() => handleClickBanner(bannerList[0])}>
              <img className="banner-item-img" src={bannerList[0].coverImageUrl} alt="banner" />
            </div>
          );
        }
        // 多张图片，使用 Carousel
        return (
          <Carousel className="banner" arrow="never">
            {bannerList.map((item) => (
              <div key={item.id} className="banner-item" onClick={() => handleClickBanner(item)}>
                <img className="banner-item-img" src={item.coverImageUrl} alt="banner" />
              </div>
            ))}
          </Carousel>
        );

      case BannerStatus.None:
        return (
          <Image
            className="banner-item-img"
            src="https://img.meituan.net/mtdxweb/099e265245e129b1ff1da7eef7a112b0233657.png"
          />
        );
      default:
        return null;
    }
  };

  const { run } = useRequest(() => getBannerList<IBanner[]>({ moduleId: bannerModuleId }), {
    manual: true,
    onSuccess: (res) => {
      setBannerList(res.data);
      setBannerStatus(res.data.length ? BannerStatus.Succ : BannerStatus.None);
    },
    onError: (err) => {
      console.log(err);
      setBannerStatus(BannerStatus.None);
    },
  });

  useEffect(() => {
    setBannerStatus(BannerStatus.Init);
    // !bannerModuleId && setBannerStatus(BannerStatus.None);
    bannerModuleId > 0 && run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerModuleId]);

  return <div className="banner-wrapper">{renderBanner()}</div>;
};
